module.exports = __webpack_public_path__ + "img/中国航空运输协会-会员证书.0fa8a62f.jpg";